module.exports = __webpack_public_path__ + "img/5f_r_belmont@2x.245f5974.png";